import React, { Component } from 'react';
import videojs from 'video.js'
import {Helmet} from 'react-helmet';

import './ViewPlayer.scss';

class ViewPlayer extends Component {
  constructor (props) {
    super(props);
  }

  componentDidMount() {    
    this.player = videojs(this.videoNode, this.props);
  }
  
  componentWillUnmount() {
    if (this.player) {
      this.player.dispose();
    }
  }
  
  render() {  
    return (
      <div>
        <Helmet>
          <link href="https://vjs.zencdn.net/6.6.3/video-js.css" rel="stylesheet" />
        </Helmet>
      <video
        className="video-js"
        ref={(c) => { this.videoNode = c; }}
      ></video>
      </div>
    );
  }
}

export default ViewPlayer;



// WEBPACK FOOTER //
// ./src/routes/recordings/components/ViewPlayer/index.js